module.exports = __webpack_public_path__ + "static/img/thumb_13.0b42cbb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_13.jpg
// module id = M3fN
// module chunks = 0